<template>
    <v-snackbar @close="$emit('close')" :active="active" :message="message" />
</template>
<<script>
export default {
    name: 'notification',
    props: {
        active: Boolean,
        message: String,
        onClose: Function,
    }
}
</script>



// WEBPACK FOOTER //
// Notification.vue?087e4b7f